
<div class="badge" [class.small]="size() === 'small'" [class.large]="size() === 'large'" [style]="getIndividualBadgeStyle()">
  @switch (status()) {
    @case ('doneManually') {
      <img src="img/check_mark.svg" alt="Done" width="11" height="11" />
    }
    @case ('doneAutomatically') {
      <img src="img/ai_magic.svg" alt="Done" width="11" height="11" />
    }
    @case ('open') {}
    @case ('next') {
      <img src="img/play_triangle.svg" alt="Done" width="11" height="11" />
    }
  }
</div>
